import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CallButton, WhatsAppButton } from "@/components/CtaButtons";

export default function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-ink-950 px-5" data-testid="not-found-page">
      <div className="text-center">
        <div className="flex justify-center">
          <Logo dark />
        </div>
        <p className="mt-12 font-display text-7xl font-black text-brand sm:text-8xl">404</p>
        <h1 className="mt-4 font-display text-2xl font-extrabold uppercase tracking-tight text-white">
          Sayfa Bulunamadı
        </h1>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-white/60">
          Aradığınız sayfa taşınmış veya kaldırılmış olabilir. Yolda kaldıysanız biz hâlâ buradayız.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <CallButton location="not_found" testid="not-found-call-button" />
          <WhatsAppButton location="not_found" testid="not-found-whatsapp-button" />
        </div>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-8 inline-block text-sm font-bold text-white/70 underline-offset-4 hover:text-white hover:underline"
        >
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
}
